<script setup>
import { useStore } from 'vuex';
import IlganPopIntro from './IlganPopIntro.vue';
import IlganPopContent from './IlganPopContent.vue';
import { getIlganPopup } from '@/api/IlganPop';
import '@/assets/nangman_style/popup/ilgan_description_mobile.scss';

const store = useStore();
const currentUserId = computed(() => store.getters['user/id']);

// import {popupData as detailExpList} from '../data/popupExp.js'

const props = defineProps({
  toggleProMode: {
    type: String,
    default: null,
  },
  pgmode: {
    type: String,
    default: null,
  },
  ilganInfo: {
    type: Object,
  },
});
const emit = defineEmits(['redirectToLogin']);
const { ...five } = fiveMixin();

// 모바일 감지
const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};
onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

const redirectToLogin = ({ redirectOption }) => emit('redirectToLogin', { redirectOption });

// 데이터 요청
/** 일간 정보에 따른 code 생성 */
const korIlgan = five.getHanguelTxt(props.ilganInfo.char, 'sky');
const dayMap = {
  tue: '화',
  wed: '수',
  thu: '목',
  fri: '금',
  sat: '토',
};
const koreanDay = computed(() => dayMap[props.ilganInfo.whichDay] || '');
const ilganCode = computed(() => `일간팝업_${korIlgan}${koreanDay.value}`);

/** code를 활용하여 정보 요청 */
const ilganDataRaw = ref({});
const fetchIlgan = async () => {
  const data = await getIlganPopup(ilganCode.value);
  ilganDataRaw.value = data;
  await nextTick();
};
const ilganData = computed(() => ilganDataRaw.value);

// 컬러코드 데이터
const colorMap = {
  tue: 'fifive01',
  wed: 'fifive02',
  thu: 'fifive03',
  fri: 'fifive04',
  sat: 'fifive05',
};
const fiveElements = computed(() => colorMap[props.ilganInfo.whichDay] || '');

const PopManseDetailBox = ref(true);
const close = () => {
  emit('close');
};
function open() {
  PopManseDetailBox.value = true;
}

/** 마우스 우클릭 방지 */
const disableRightClick = (event) => {
  event.preventDefault();
};

onMounted(async () => {
  fetchIlgan();
  await nextTick();
  document.addEventListener('contextmenu', disableRightClick);
});

onBeforeUnmount(() => {
  document.removeEventListener('contextmenu', disableRightClick);
});

/** 콘텐트로 넘어가기 */
const isContentVisible = ref(false);
const showIlganContent = async () => {
  // 비로그인 상태에서 받은 pages가 비어있으면 로그인 후 재조회
  if (!ilganDataRaw.value?.pages?.length && currentUserId.value) {
    await fetchIlgan();
  }
  isContentVisible.value = true;
};

/** 다시보기 */
const showIntro = () => {
  isContentVisible.value = false;
};

watch(PopManseDetailBox, (newState) => {
  if (!newState) close();
});
</script>
<template>
  <VDialog
    v-model="PopManseDetailBox"
    v-bind="
      isMobile
        ? { width: '100%', maxWidth: '100%', fullscreen: true }
        : { width: '740px', height: '734px', maxWidth: '100%' }
    "
    class="dialog-ilgan-five dialog-saju-keyword"
  >
    <VCard
      :class="isMobile ? 'ilgan-inner-cd' : 'br16 ilgan-inner-cd'"
      :style="isMobile ? { height: '100%', overflow: 'hidden' } : {}"
    >
      <div class="ilgan-inner-cd" :class="[fiveElements, { mobile: isMobile }]">
        <template v-if="!isContentVisible">
          <!-- 모바일: 닫기 버튼을 pop-tit-box 없이 absolute 배치 (모바일 전용 페이지와 동일) -->
          <template v-if="isMobile">
            <button class="dial-close ilganIntro" @click="close"></button>
            <div v-if="Object.keys(ilganData).length" class="pop-detail-body">
              <IlganPopIntro
                @show-content-page="showIlganContent"
                :ilganData="ilganData"
                :fiveElements="fiveElements"
                @redirectToLogin="redirectToLogin"
              />
            </div>
          </template>
          <!-- PC: 기존 구조 유지 -->
          <template v-else>
            <div class="pop-tit-box">
              <button class="dial-close ilganIntro" @click="close"></button>
            </div>
            <div class="pop-detail-body">
              <IlganPopIntro
                v-if="Object.keys(ilganData).length"
                @show-content-page="showIlganContent"
                :ilganData="ilganData"
                :fiveElements="fiveElements"
                @redirectToLogin="redirectToLogin"
              />
            </div>
          </template>
        </template>
        <IlganPopContent v-else :ilganData="ilganData" @close="close" @showIntro="showIntro" />
      </div>
    </VCard>
  </VDialog>
</template>
